import { env } from '@/common/env'
import monitor from '@/common/monitor'

const bridge = {
  openPage(url: string, query: Record<string, any> = {}) {
    console.log('openPage:', url)
    if (!env.isTitans) {
      location.href = url
      return
    }
    KNB.ready(() => {
      KNB.openPage({
        url,
        query,
        fail: (e) => {
          monitor.captureMessage({
            name: 'KNB.openPage 失败',
            msg: { url, e },
          })
          location.href = url
        },
      })
    })
  },
  closePage() {
    KNB.ready(() => {
      KNB.closePage()
    })
  },
  getUserInfo(): Promise<any> {
    return new Promise((resolve) => {
      KNB.ready(() => {
        KNB.getUserInfo({
          success: (user) => {
            resolve(user || {})
          },
          fail: () => {
            resolve({})
          },
        })
      })
    })
  },
  getAppInfo(): Promise<any> {
    return new Promise((resolve) => {
      KNB.getAppInfo({
        success: (appInfo: any) => {
          resolve(appInfo || {})
        },
        fail: () => {
          resolve({})
        },
      })
    })
  },
  getFingerprint(): Promise<any> {
    return new Promise((resolve) => {
      KNB.getFingerprint({
        success: (ret) => {
          resolve(ret || {})
        },
        fail: () => {
          resolve({})
        },
      })
    })
  },
  getCity(): Promise<any> {
    return new Promise((resolve) => {
      KNB.getCity({
        success: (city) => {
          console.log(city)
          resolve(city || {})
        },
        fail: () => {
          resolve({})
        },
      })
    })
  },
  setStatusBarStyle({ style = 1, backgroundColor = 'rgba(0,0,0,0)' }) {
    KNB.setStatusBarStyle({
      style, //1:状态栏字体为白色, 0:状态栏字体为黑色，仅 iOS 支持
      backgroundColor, // 状态栏背景色，rgba 色值，仅 Android 在 titans >= 11.18.7 支持。backgroundColor必填，写不为空字符串，否则桥调用会失败！backgroundColor只支持3位(rgb)、6位(rgb)、4位(rgba)、8位(rgba)格式
      success: function () {},
      fail: function () {},
    })
  },
}

export default bridge
